var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.203,
    height: 25.203,
    viewBox: "0 0 25.203 25.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_1_",
    "data-name": "check (1)",
    d: "M25.2,13.1a12.552,12.552,0,0,1-2.135,7A.985.985,0,0,1,21.431,19a10.606,10.606,0,0,0,1.468-8.56.985.985,0,0,1,1.907-.491,12.647,12.647,0,0,1,.4,3.15Zm-7.1,9.1a10.633,10.633,0,1,1,.536-17.856.985.985,0,1,0,1.119-1.62A12.6,12.6,0,0,0,3.691,22.013a12.606,12.606,0,0,0,15.431,1.875A.985.985,0,1,0,18.1,22.2ZM12.7,15.957a.561.561,0,0,1-.415-.157L7.126,10.911A.984.984,0,0,0,5.771,12.34l5.155,4.888a2.514,2.514,0,0,0,1.745.7l.1,0a2.516,2.516,0,0,0,1.788-.843l.034-.04L24.986,4.12a.985.985,0,0,0-1.535-1.234l-10.368,12.9a.563.563,0,0,1-.386.174Zm0,0",
    transform: "translate(0 -0.5)",
    fill: "#14b7dd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b7cdcb12af63828b08a3fab5043462df.svg";
export { ForwardRef as ReactComponent };